import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import { ContainerFlex } from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM158,
    ContenidoM158,
    ZonaTrabajoM158,
    EnunciadoM158,
    ActividadM158,
    LateralM158,
    EscenaM158,
    BottomM158
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 3;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222222';
const PINTADO = '#F2A541';

const MAX_PARTES = 12;

const BASE = 27720;


const miniInstrucciones =
    'Repartí todos los chocolates en partes iguales, escribí cuánto recibe cada amigo y ubicalo en la recta.';


// ============================================================================
// AMIGOS
// ============================================================================

const AMIGOS = [

    {
        nombre: 'Pepito',
        color: '#4FA3D1'
    },

    {
        nombre: 'Juana',
        color: '#F06292'
    },

    {
        nombre: 'Tomi',
        color: '#66BB6A'
    },

    {
        nombre: 'Lola',
        color: '#FFA726'
    },

    {
        nombre: 'Fran',
        color: '#AB47BC'
    },

    {
        nombre: 'Mati',
        color: '#26A69A'
    }

];


// ============================================================================
// REPARTOS
// ============================================================================

const REPARTOS = [

    {
        chocolates: 3,
        amigos: 3
    },

    {
        chocolates: 1,
        amigos: 2
    },

    {
        chocolates: 2,
        amigos: 4
    },

    {
        chocolates: 3,
        amigos: 4
    },

    {
        chocolates: 2,
        amigos: 3
    },

    {
        chocolates: 3,
        amigos: 2
    },

    {
        chocolates: 5,
        amigos: 4
    },

    {
        chocolates: 2,
        amigos: 5
    },

    {
        chocolates: 4,
        amigos: 3
    },

    {
        chocolates: 5,
        amigos: 2
    },

    {
        chocolates: 3,
        amigos: 6
    },

    {
        chocolates: 4,
        amigos: 6
    }

];


// ============================================================================
// AUXILIARES
// ============================================================================

const range = cantidad => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const cursor = activo => ({
    cursor:
        activo
            ? 'pointer'
            : 'default'
});


const gcd = (
    a,
    b
) => {

    return (
        b === 0

            ? a

            : gcd(
                b,
                a % b
            )
    );
};


const mezclar = array => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i + 1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


// ============================================================================
// SELECCIÓN
//
// 1 resultado < 1
// 1 resultado = 1
// 1 resultado > 1
// ============================================================================

const seleccionarEjercicios = () => {

    const menores =
        mezclar(
            REPARTOS.filter(
                item =>
                    item.chocolates <
                    item.amigos
            )
        );


    const iguales =
        mezclar(
            REPARTOS.filter(
                item =>
                    item.chocolates ===
                    item.amigos
            )
        );


    const mayores =
        mezclar(
            REPARTOS.filter(
                item =>
                    item.chocolates >
                    item.amigos
            )
        );


    return mezclar([
        menores[0],
        iguales[0],
        mayores[0]
    ]);
};


// ============================================================================
// FRACCIÓN
// ============================================================================

const Fraccion = ({
    num,
    den,
    size = 80,
    color = INK
}) => {

    return (

        <span
            style={{
                display: 'inline-flex',
                flexDirection: 'column',
                alignItems: 'center',
                fontFamily: 'Nunito',
                fontWeight: 800,
                color,
                lineHeight: 1
            }}
        >

            <span
                style={{
                    fontSize: size
                }}
            >
                {num}
            </span>


            <span
                style={{
                    width: size * 0.9,
                    height: Math.max(
                        3,
                        size / 14
                    ),
                    background: color,
                    borderRadius: 2,
                    margin: `${size * 0.08}px 0`
                }}
            />


            <span
                style={{
                    fontSize: size
                }}
            >
                {den}
            </span>

        </span>
    );
};


// ============================================================================
// NÚMERO MIXTO
// ============================================================================

const Numero = ({
    e,
    num,
    den,
    size = 80,
    color = INK
}) => {

    return (

        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: size * 0.2,
                fontFamily: 'Nunito',
                fontWeight: 800,
                color
            }}
        >

            {
                e > 0 && (

                    <span
                        style={{
                            fontSize:
                                size * 1.25,

                            lineHeight:
                                1
                        }}
                    >
                        {e}
                    </span>
                )
            }


            {
                num > 0 && (

                    <Fraccion
                        num={num}
                        den={den}
                        size={size}
                        color={color}
                    />
                )
            }

        </span>
    );
};


// ============================================================================
// BOTONES
// ============================================================================

const boton = {

    fontFamily: 'Nunito',

    fontSize: 16,

    fontWeight: 600,

    padding: '7px 14px',

    borderRadius: 11,

    border: `2px solid ${ACCENT}`,

    background: '#FFFFFF',

    color: ACCENT,

    cursor: 'pointer'
};


const botonPequeno = {

    ...boton,

    padding: '2px 11px',

    fontSize: 20,

    lineHeight: 1
};


// ============================================================================
// CONTADOR
// ============================================================================

const Contador = ({
    valor,
    onCambio,
    min,
    etiqueta,
    vertical = false,
    disabled
}) => {


    const restar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? min

                : Math.max(
                    min,
                    valor - 1
                )
        );
    };


    const sumar = () => {

        if (
            disabled
        ) {

            return;
        }


        onCambio(

            valor === null

                ? Math.max(
                    min,
                    1
                )

                : Math.min(
                    30,
                    valor + 1
                )
        );
    };


    const menos = (

        <button
            type="button"
            style={{
                ...botonPequeno,

                opacity:
                    disabled
                        ? 0.4
                        : 1
            }}
            disabled={disabled}
            onClick={restar}
            aria-label={`Restar ${etiqueta}`}
        >
            −
        </button>
    );


    const mas = (

        <button
            type="button"
            style={{
                ...botonPequeno,

                opacity:
                    disabled
                        ? 0.4
                        : 1
            }}
            disabled={disabled}
            onClick={sumar}
            aria-label={`Sumar ${etiqueta}`}
        >
            +
        </button>
    );


    return (

        <div
            style={{
                display: 'flex',

                flexDirection:
                    vertical
                        ? 'column'
                        : 'row',

                alignItems: 'center',

                gap:
                    vertical
                        ? 7
                        : 10
            }}
        >

            {
                vertical
                    ? mas
                    : menos
            }


            <div
                style={{
                    width: 54,
                    height: 54,

                    border:
                        `3px solid ${INK}`,

                    borderRadius:
                        10,

                    display: 'flex',

                    alignItems: 'center',
                    justifyContent: 'center',

                    fontFamily: 'Nunito',

                    fontSize: 29,

                    fontWeight: 700,

                    color:
                        valor === null
                            ? '#AAAAAA'
                            : INK
                }}
            >
                {
                    valor === null
                        ? '?'
                        : valor
                }
            </div>


            {
                vertical
                    ? menos
                    : mas
            }

        </div>
    );
};


// ============================================================================
// CHOCOLATE
// ============================================================================

const CW = 230;
const CH = 104;


const Chocolate = ({
    n,
    duenos,
    onTocar,
    activo
}) => {

    const cols =
        6;

    const rows =
        3;


    const cw =
        CW /
        cols;

    const ch =
        CH /
        rows;


    const anchoParte =
        CW /
        n;


    return (

        <svg
            viewBox={`0 0 ${CW + 12} ${CH + 12}`}
            style={{
                width: CW + 12,
                maxWidth: '100%',
                height: 'auto',
                display: 'block'
            }}
            role="img"
            aria-label="Chocolate"
        >

            <g
                pointerEvents="none"
            >

                <rect
                    x={2}
                    y={2}
                    width={CW + 8}
                    height={CH + 8}
                    rx={8}
                    fill="#7B4A2A"
                />


                {
                    range(
                        cols
                    )
                        .map(
                            columna =>

                                range(
                                    rows
                                )
                                    .map(
                                        fila => {

                                            const x =
                                                6 +
                                                columna *
                                                cw +
                                                3;

                                            const y =
                                                6 +
                                                fila *
                                                ch +
                                                3;

                                            const width =
                                                cw -
                                                6;

                                            const height =
                                                ch -
                                                6;


                                            return (

                                                <g
                                                    key={`${columna}-${fila}`}
                                                >

                                                    <rect
                                                        x={x}
                                                        y={y}
                                                        width={width}
                                                        height={height}
                                                        rx={3}
                                                        fill="#94592F"
                                                    />


                                                    <path
                                                        d={
                                                            `M${x + 2} ${y + height - 2}
                                                             L${x + 2} ${y + 2}
                                                             L${x + width - 2} ${y + 2}`
                                                        }
                                                        fill="none"
                                                        stroke="#B07446"
                                                        strokeWidth={2.5}
                                                        strokeLinecap="round"
                                                    />


                                                    <path
                                                        d={
                                                            `M${x + width - 2} ${y + 2}
                                                             L${x + width - 2} ${y + height - 2}
                                                             L${x + 2} ${y + height - 2}`
                                                        }
                                                        fill="none"
                                                        stroke="#5A3420"
                                                        strokeWidth={2.5}
                                                        strokeLinecap="round"
                                                    />

                                                </g>
                                            );
                                        }
                                    )
                        )
                }


                {
                    range(
                        n
                    )
                        .map(
                            index =>

                                duenos[index] !== null && (

                                    <rect
                                        key={`dueno-${index}`}
                                        x={
                                            6 +
                                            index *
                                            anchoParte
                                        }
                                        y={2}
                                        width={anchoParte}
                                        height={CH + 8}
                                        fill={
                                            AMIGOS[
                                                duenos[index]
                                            ].color
                                        }
                                        opacity={0.65}
                                    />
                                )
                        )
                }


                {
                    range(
                        n - 1
                    )
                        .map(
                            index => (

                                <line
                                    key={`linea-${index}`}
                                    x1={
                                        6 +
                                        (
                                            index +
                                            1
                                        ) *
                                        anchoParte
                                    }
                                    y1={0}
                                    x2={
                                        6 +
                                        (
                                            index +
                                            1
                                        ) *
                                        anchoParte
                                    }
                                    y2={CH + 12}
                                    stroke="#FFFFFF"
                                    strokeWidth={5}
                                />
                            )
                        )
                }

            </g>


            {
                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={`click-${index}`}
                                x={
                                    6 +
                                    index *
                                    anchoParte
                                }
                                y={0}
                                width={anchoParte}
                                height={CH + 12}
                                fill="transparent"
                                style={cursor(activo)}
                                onClick={() => {

                                    if (
                                        activo
                                    ) {

                                        onTocar(
                                            index
                                        );
                                    }
                                }}
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// AMIGO
// ============================================================================

const Amigo = ({
    amigo,
    seleccionado,
    pedazos,
    onClick,
    activo
}) => {

    return (

        <button
            type="button"
            onClick={onClick}
            disabled={!activo}
            aria-pressed={seleccionado}
            className="amigo-m158"
            style={{
                borderColor:
                    seleccionado
                        ? INK
                        : '#EEEEEE',

                opacity:
                    activo
                        ? 1
                        : 0.85
            }}
        >

            <svg
                width={42}
                height={42}
                viewBox="0 0 64 64"
                aria-hidden="true"
            >

                <circle
                    cx={32}
                    cy={32}
                    r={29}
                    fill={amigo.color}
                />


                <circle
                    cx={23}
                    cy={27}
                    r={3.5}
                    fill={INK}
                />


                <circle
                    cx={41}
                    cy={27}
                    r={3.5}
                    fill={INK}
                />


                <path
                    d="M21 39 Q32 49 43 39"
                    fill="none"
                    stroke={INK}
                    strokeWidth={3}
                    strokeLinecap="round"
                />

            </svg>


            <span
                className="datos-amigo-m158"
            >

                <span
                    className="nombre-amigo-m158"
                >
                    {amigo.nombre}
                </span>


                <span
                    className="pedazos-amigo-m158"
                >

                    {
                        pedazos.map(
                            (
                                denominador,
                                index
                            ) => (

                                <span
                                    key={index}
                                    style={{
                                        background:
                                            amigo.color
                                    }}
                                >
                                    {
                                        denominador === 1

                                            ? '1'

                                            : `1/${denominador}`
                                    }
                                </span>
                            )
                        )
                    }

                </span>

            </span>

        </button>
    );
};


// ============================================================================
// RECTA
// ============================================================================

const VW = 900;
const X0 = 60;
const Y = 120;
const VH = 190;


const Recta = ({
    limite,
    recta,
    color,
    onTocarParte,
    onClic,
    activo,
    etiqueta
}) => {

    const UNIT =
        (
            VW -
            2 *
            X0
        ) /
        limite;


    const toX = valor =>
        X0 +
        valor *
        UNIT;


    const TY =
        Y -
        62;


    const TH =
        44;


    const clic = e => {

        if (
            !activo
        ) {

            return;
        }


        const svg =
            e.currentTarget
                .ownerSVGElement;


        if (
            !svg
        ) {

            return;
        }


        const pt =
            svg.createSVGPoint();


        pt.x =
            e.clientX;

        pt.y =
            e.clientY;


        const matrix =
            svg.getScreenCTM();


        if (
            !matrix
        ) {

            return;
        }


        const local =
            pt.matrixTransform(
                matrix.inverse()
            );


        onClic(

            Math.max(
                0,
                Math.min(
                    limite,
                    (
                        local.x -
                        X0
                    ) /
                    UNIT
                )
            ),

            UNIT
        );
    };


    return (

        <svg
            viewBox={`0 0 ${VW} ${VH}`}
            style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                userSelect: 'none'
            }}
            role="img"
            aria-label="Recta numérica"
        >

            <line
                x1={toX(0) - 40}
                y1={Y}
                x2={toX(limite) + 40}
                y2={Y}
                stroke={INK}
                strokeWidth={3}
            />


            <polygon
                points={
                    `${toX(0) - 52},${Y} ${toX(0) - 38},${Y - 8} ${toX(0) - 38},${Y + 8}`
                }
                fill={INK}
            />


            <polygon
                points={
                    `${toX(limite) + 52},${Y} ${toX(limite) + 38},${Y - 8} ${toX(limite) + 38},${Y + 8}`
                }
                fill={INK}
            />


            {
                range(
                    limite +
                    1
                )
                    .map(
                        entero => (

                            <g
                                key={entero}
                            >

                                <line
                                    x1={toX(entero)}
                                    y1={Y - 12}
                                    x2={toX(entero)}
                                    y2={Y + 12}
                                    stroke={INK}
                                    strokeWidth={3}
                                />


                                <text
                                    x={toX(entero)}
                                    y={Y + 38}
                                    textAnchor="middle"
                                    fontSize="22"
                                    fontWeight="600"
                                    fill={INK}
                                >
                                    {entero}
                                </text>

                            </g>
                        )
                    )
            }


            <rect
                x={toX(0) - 20}
                y={Y - 14}
                width={
                    UNIT *
                    limite +
                    40
                }
                height={56}
                fill="transparent"
                style={cursor(activo)}
                onClick={
                    activo
                        ? clic
                        : undefined
                }
            />


            {
                range(
                    recta.B
                )
                    .map(
                        bandeja => (

                            <g
                                key={bandeja}
                            >

                                {
                                    range(
                                        recta.p
                                    )
                                        .map(
                                            parte => (

                                                <rect
                                                    key={parte}
                                                    x={
                                                        toX(
                                                            bandeja
                                                        ) +
                                                        (
                                                            parte *
                                                            UNIT
                                                        ) /
                                                        recta.p
                                                    }
                                                    y={TY}
                                                    width={
                                                        UNIT /
                                                        recta.p
                                                    }
                                                    height={TH}
                                                    fill={
                                                        recta.pint[
                                                            bandeja *
                                                            recta.p +
                                                            parte
                                                        ]

                                                            ? color
                                                            : '#F4F1EC'
                                                    }
                                                    stroke="#333333"
                                                    strokeWidth={2}
                                                    style={cursor(activo)}
                                                    onClick={() => {

                                                        if (
                                                            activo
                                                        ) {

                                                            onTocarParte(
                                                                bandeja,
                                                                parte
                                                            );
                                                        }
                                                    }}
                                                />
                                            )
                                        )
                                }


                                <rect
                                    x={toX(bandeja)}
                                    y={TY}
                                    width={UNIT}
                                    height={TH}
                                    fill="none"
                                    stroke="#333333"
                                    strokeWidth={3}
                                    rx={3}
                                    pointerEvents="none"
                                />

                            </g>
                        )
                    )
            }


            {
                recta.mark !== null && (

                    <g
                        pointerEvents="none"
                    >

                        <circle
                            cx={toX(recta.mark)}
                            cy={Y}
                            r={10}
                            fill={
                                etiqueta
                                    ? OK
                                    : MARK
                            }
                            stroke="#FFFFFF"
                            strokeWidth={2}
                        />


                        {
                            etiqueta && (

                                <text
                                    x={toX(recta.mark)}
                                    y={Y + 34}
                                    textAnchor="middle"
                                    fontSize="19"
                                    fontWeight="800"
                                    fill={OK}
                                >
                                    {etiqueta}
                                </text>
                            )
                        }

                    </g>
                )
            }

        </svg>
    );
};


// ============================================================================
// CONTROLES RECTA
// ============================================================================

const ControlesRecta = ({
    recta,
    limite,
    onCambio,
    activo
}) => {


    const poner = () => {

        if (
            !activo ||
            recta.B >= limite
        ) {

            return;
        }


        onCambio({

            B:
                recta.B + 1,

            pint: [
                ...recta.pint,

                ...Array(
                    recta.p
                ).fill(
                    false
                )
            ]
        });
    };


    const sacar = () => {

        if (
            !activo ||
            recta.B <= 0
        ) {

            return;
        }


        const nuevaCantidad =
            recta.B -
            1;


        onCambio({

            B:
                nuevaCantidad,

            pint:
                recta.pint.slice(
                    0,
                    nuevaCantidad *
                    recta.p
                )
        });
    };


    const partir = partes => {

        if (
            !activo
        ) {

            return;
        }


        onCambio({

            p:
                partes,

            pint:
                Array(
                    recta.B *
                    partes
                ).fill(
                    false
                )
        });
    };


    if (
        !activo
    ) {

        return null;
    }


    return (

        <div
            className="controles-recta-m158"
        >

            <button
                type="button"
                style={{
                    ...boton,

                    opacity:
                        recta.B >= limite
                            ? 0.4
                            : 1
                }}
                disabled={
                    recta.B >= limite
                }
                onClick={poner}
            >
                Poner bandeja
            </button>


            {
                recta.B > 0 && (

                    <button
                        type="button"
                        style={{
                            ...boton,

                            borderColor:
                                MARK,

                            color:
                                MARK
                        }}
                        onClick={sacar}
                    >
                        Sacar bandeja
                    </button>
                )
            }


            {
                recta.B > 0 && (

                    <div
                        className="partir-recta-m158"
                    >

                        <span>
                            Partir en:
                        </span>


                        <button
                            type="button"
                            style={{
                                ...botonPequeno,

                                opacity:
                                    recta.p <= 1
                                        ? 0.4
                                        : 1
                            }}
                            disabled={
                                recta.p <= 1
                            }
                            onClick={() =>
                                partir(
                                    recta.p - 1
                                )
                            }
                        >
                            −
                        </button>


                        <span>
                            {recta.p}
                        </span>


                        <button
                            type="button"
                            style={{
                                ...botonPequeno,

                                opacity:
                                    recta.p >= MAX_PARTES
                                        ? 0.4
                                        : 1
                            }}
                            disabled={
                                recta.p >= MAX_PARTES
                            }
                            onClick={() =>
                                partir(
                                    recta.p + 1
                                )
                            }
                        >
                            +
                        </button>

                    </div>
                )
            }

        </div>
    );
};


// ============================================================================
// ESTADO INICIAL
// ============================================================================

const inicial = reparto => ({

    etapa:
        0,

    hecho:
        false,

    partes:
        Array(
            reparto.chocolates
        ).fill(
            1
        ),

    duenos:
        range(
            reparto.chocolates
        )
            .map(
                () => [
                    null
                ]
            ),

    sel:
        0,

    ent:
        null,

    num:
        null,

    den:
        null,

    recta: {

        B:
            0,

        p:
            1,

        pint:
            [],

        mark:
            null
    }
});


// ============================================================================
// M158
// ============================================================================

const M158 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // =========================================================================
    // REDUX
    // =========================================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================================
    // EJERCICIOS
    // =========================================================================

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(0);


    const [
        st,
        setSt
    ] = useState(
        inicial(
            REPARTOS[0]
        )
    );


    // =========================================================================
    // FEEDBACK
    // =========================================================================

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    // =========================================================================
    // ERRORES
    // =========================================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // =========================================================================
    // ACTUAL
    // =========================================================================

    const repartoActual =
        ejercicios.length > 0

            ? ejercicios[
                count
            ]

            : null;


    const chocolates =
        repartoActual
            ? repartoActual.chocolates
            : 1;


    const cantidadAmigos =
        repartoActual
            ? repartoActual.amigos
            : 2;


    const amigos =
        AMIGOS.slice(
            0,
            cantidadAmigos
        );


    const valor =
        chocolates /
        cantidadAmigos;


    const divisor =
        gcd(
            chocolates,
            cantidadAmigos
        );


    const tNum =
        chocolates /
        divisor;


    const tDen =
        cantidadAmigos /
        divisor;


    const enteroResultado =
        Math.floor(
            tNum /
            tDen
        );


    const restoResultado =
        tNum %
        tDen;


    const resultado = {

        e:
            enteroResultado,

        num:
            restoResultado,

        den:
            tDen
    };


    const limiteRecta =
        Math.ceil(
            valor
        ) +
        2;


    const activoReparto =
        st.etapa === 0 &&
        !st.hecho &&
        !disable;


    const activoRecta =
        st.etapa === 2 &&
        !st.hecho &&
        !disable;


    // =========================================================================
    // PEDAZOS DE CADA AMIGO
    // =========================================================================

    const pedazos =
        amigos.map(
            (
                _,
                amigoIndex
            ) => {

                const lista = [];


                st.duenos.forEach(
                    (
                        duenosChocolate,
                        chocolateIndex
                    ) => {

                        duenosChocolate.forEach(
                            dueno => {

                                if (
                                    dueno ===
                                    amigoIndex
                                ) {

                                    lista.push(
                                        st.partes[
                                            chocolateIndex
                                        ]
                                    );
                                }
                            }
                        );
                    }
                );


                return lista.sort(
                    (
                        a,
                        b
                    ) =>
                        a -
                        b
                );
            }
        );


    const suma =
        pedazos.map(
            lista =>

                lista.reduce(
                    (
                        acumulador,
                        denominador
                    ) =>

                        acumulador +
                        BASE /
                        denominador,

                    0
                )
        );


    // =========================================================================
    // ETIQUETA RECTA
    // =========================================================================

    const textoResultado = () => {

        if (
            restoResultado === 0
        ) {

            return (
                `${enteroResultado}`
            );
        }


        if (
            enteroResultado > 0
        ) {

            return (
                `${enteroResultado} y ${restoResultado}/${tDen}`
            );
        }


        return (
            `${tNum}/${tDen}`
        );
    };


    const etiquetaRecta =
        st.etapa === 2 &&
        st.hecho

            ? textoResultado()

            : null;


    // =========================================================================
    // GUARDADO
    // =========================================================================

    const textoEstimulo = () => {

        return (
            `${chocolates}C/${cantidadAmigos}A`
        );
    };


    // =========================================================================
    // SONIDOS
    // =========================================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================================
    // ACTUALIZAR
    // =========================================================================

    const actualizar = cambios => {

        setSt(
            anterior => ({

                ...anterior,

                ...(
                    typeof cambios === 'function'

                        ? cambios(
                            anterior
                        )

                        : cambios
                )
            })
        );


        setFeedback(
            null
        );
    };


    // =========================================================================
    // DESCRIBIR PEDAZOS
    // =========================================================================

    const describirPedazos = lista => {

        if (
            lista.length === 0
        ) {

            return (
                'nada'
            );
        }


        if (
            lista.every(
                denominador =>
                    denominador ===
                    lista[0]
            )
        ) {

            if (
                lista[0] === 1
            ) {

                return (
                    `${lista.length} ${
                        lista.length === 1
                            ? 'chocolate entero'
                            : 'chocolates enteros'
                    }`
                );
            }


            return (
                `${lista.length} ${
                    lista.length === 1
                        ? 'pedazo'
                        : 'pedazos'
                } de 1/${lista[0]}`
            );
        }


        return lista
            .map(
                denominador =>

                    denominador === 1

                        ? '1'

                        : `1/${denominador}`
            )
            .join(
                ' + '
            );
    };


    // =========================================================================
    // PARTIR CHOCOLATE
    // =========================================================================

    const partirChocolate = (
        chocolateIndex,
        delta
    ) => {

        if (
            !activoReparto
        ) {

            return;
        }


        actualizar(
            anterior => {

                const nuevoN =
                    Math.max(
                        1,
                        Math.min(
                            MAX_PARTES,
                            anterior.partes[
                                chocolateIndex
                            ] +
                            delta
                        )
                    );


                return {

                    partes:
                        anterior.partes.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index ===
                                chocolateIndex

                                    ? nuevoN
                                    : valorActual
                        ),

                    duenos:
                        anterior.duenos.map(
                            (
                                duenosActuales,
                                index
                            ) =>

                                index ===
                                chocolateIndex

                                    ? Array(
                                        nuevoN
                                    ).fill(
                                        null
                                    )

                                    : duenosActuales
                        )
                };
            }
        );
    };


    // =========================================================================
    // ASIGNAR PEDAZO
    // =========================================================================

    const tocarChocolate = (
        chocolateIndex,
        parteIndex
    ) => {

        if (
            !activoReparto
        ) {

            return;
        }


        actualizar(
            anterior => ({

                duenos:
                    anterior.duenos.map(
                        (
                            duenosChocolate,
                            index
                        ) => {

                            if (
                                index !==
                                chocolateIndex
                            ) {

                                return duenosChocolate;
                            }


                            return duenosChocolate.map(
                                (
                                    duenoActual,
                                    indexParte
                                ) => {

                                    if (
                                        indexParte !==
                                        parteIndex
                                    ) {

                                        return duenoActual;
                                    }


                                    return (
                                        duenoActual ===
                                        anterior.sel

                                            ? null

                                            : anterior.sel
                                    );
                                }
                            );
                        }
                    )
            })
        );
    };


    // =========================================================================
    // RECTA
    // =========================================================================

    const cambiarRecta = cambios => {

        actualizar(
            anterior => {

                const cambiosRecta =
                    typeof cambios === 'function'

                        ? cambios(
                            anterior.recta
                        )

                        : cambios;


                return {

                    recta: {

                        ...anterior.recta,

                        ...cambiosRecta
                    }
                };
            }
        );
    };


    const tocarRecta = (
        bandeja,
        parte
    ) => {

        if (
            !activoRecta
        ) {

            return;
        }


        cambiarRecta(
            recta => {

                const posicion =
                    bandeja *
                    recta.p +
                    parte;


                return {

                    pint:
                        recta.pint.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index ===
                                posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    const marcarRecta = (
        numero,
        UNIT
    ) => {

        if (
            !activoRecta
        ) {

            return;
        }


        cambiarRecta(
            recta => {

                let marca =
                    Math.round(
                        numero *
                        1000
                    ) /
                    1000;


                if (
                    recta.B > 0 &&
                    recta.p > 1
                ) {

                    const paso =
                        Math.round(
                            numero *
                            recta.p
                        ) /
                        recta.p;


                    if (
                        Math.abs(
                            paso -
                            numero
                        ) *
                        UNIT <
                        14
                    ) {

                        marca =
                            paso;
                    }
                }


                return {

                    mark:
                        marca
                };
            }
        );
    };


    // =========================================================================
    // ERROR
    // =========================================================================

    const marcarError = texto => {

        setContarErrores(
            errores =>
                errores +
                1
        );


        setErroresItemActual(
            errores =>
                errores +
                1
        );


        setFeedback({

            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );


            setDisable(
                false
            );

        }, 300);
    };


    // =========================================================================
    // CORRECTO
    // =========================================================================

    const etapaCorrecta = texto => {

        const etapaActual =
            st.etapa;


        setDisable(
            true
        );


        setIsCorrect(
            true
        );


        setSt(
            anterior => ({

                ...anterior,

                hecho:
                    true
            })
        );


        setFeedback({

            ok:
                true,

            text:
                texto
        });


        GoodWork();


        setTimeout(() => {


            setIsCorrect(
                false
            );


            // =================================================================
            // SIGUIENTE ETAPA
            // =================================================================

            if (
                etapaActual <
                2
            ) {

                setSt(
                    anterior => ({

                        ...anterior,

                        etapa:
                            etapaActual +
                            1,

                        hecho:
                            false
                    })
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ SITUACIÓN
            // =================================================================

            const nuevaLista = [

                ...respuestasOrden,

                textoEstimulo()

            ];


            const nuevosErrores = [

                ...erroresOrden,

                erroresItemActual

            ];


            setRespuestasOrden(
                nuevaLista
            );


            setErroresOrden(
                nuevosErrores
            );


            // =================================================================
            // SIGUIENTE EJERCICIO
            // =================================================================

            if (
                count <
                ejercicios.length -
                1
            ) {

                const siguiente =
                    count +
                    1;


                setCount(
                    siguiente
                );


                setSt(
                    inicial(
                        ejercicios[
                            siguiente
                        ]
                    )
                );


                setErroresItemActual(
                    0
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // FIN M158
            // =================================================================

            setFeedback(
                null
            );


            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 50);


        }, 300);
    };


    // =========================================================================
    // COMPROBAR
    // =========================================================================

    const comprobar = () => {

        if (
            disable ||
            st.hecho ||
            !repartoActual
        ) {

            return;
        }


        // =====================================================================
        // ETAPA 1
        // REPARTIR
        // =====================================================================

        if (
            st.etapa === 0
        ) {

            const haySinRepartir =
                st.duenos.some(
                    duenosChocolate =>
                        duenosChocolate.includes(
                            null
                        )
                );


            if (
                haySinRepartir
            ) {

                marcarError(
                    'Todavía hay pedazos sin repartir. Tenés que repartir todo.'
                );


                return;
            }


            const sinNada =
                suma.findIndex(
                    valorAmigo =>
                        valorAmigo ===
                        0
                );


            if (
                sinNada >= 0
            ) {

                marcarError(
                    `${amigos[sinNada].nombre} todavía no recibió nada.`
                );


                return;
            }


            const maximo =
                Math.max(
                    ...suma
                );


            const minimo =
                Math.min(
                    ...suma
                );


            if (
                maximo !==
                minimo
            ) {

                const tieneMas =
                    suma.indexOf(
                        maximo
                    );


                const tieneMenos =
                    suma.indexOf(
                        minimo
                    );


                marcarError(
                    `${amigos[tieneMas].nombre} tiene más que ${amigos[tieneMenos].nombre}. Todos tienen que recibir lo mismo.`
                );


                return;
            }


            etapaCorrecta(
                `¡Muy bien! Todos recibieron lo mismo: ${describirPedazos(pedazos[0])}.`
            );


            return;
        }


        // =====================================================================
        // ETAPA 2
        // ESCRIBIR CUÁNTO LE TOCA
        // =====================================================================

        if (
            st.etapa === 1
        ) {

            // ================================================================
            // RESULTADO ENTERO EXACTO
            // Ejemplo: 3 chocolates / 3 amigos = 1
            // ================================================================

            if (
                restoResultado === 0
            ) {

                if (
                    st.ent === null
                ) {

                    marcarError(
                        'Completá cuántos chocolates enteros recibe cada amigo.'
                    );


                    return;
                }


                if (
                    st.ent ===
                    enteroResultado
                ) {

                    etapaCorrecta(
                        `¡Muy bien! A cada uno le toca ${enteroResultado} ${
                            enteroResultado === 1
                                ? 'chocolate'
                                : 'chocolates'
                        }.`
                    );


                    return;
                }


                marcarError(
                    `Pensá en el reparto: hay ${chocolates} ${
                        chocolates === 1
                            ? 'chocolate'
                            : 'chocolates'
                    } para ${cantidadAmigos} amigos.`
                );


                return;
            }


            // ================================================================
            // RESULTADO MAYOR QUE 1
            // Ejemplo: 3 / 2 = 1 y 1/2
            // ================================================================

            if (
                enteroResultado > 0
            ) {

                if (
                    st.ent === null
                ) {

                    marcarError(
                        'Completá primero cuántos chocolates enteros recibe cada amigo.'
                    );


                    return;
                }


                if (
                    st.num === null ||
                    st.den === null
                ) {

                    marcarError(
                        'Completá también la fracción.'
                    );


                    return;
                }


                const fraccionCorrecta =
                    st.num *
                    tDen ===
                    restoResultado *
                    st.den;


                if (
                    st.ent === enteroResultado &&
                    st.num < st.den &&
                    fraccionCorrecta
                ) {

                    etapaCorrecta(
                        `¡Muy bien! A cada uno le toca ${textoResultado()}.`
                    );


                    return;
                }


                marcarError(
                    `Mirá lo que recibió ${amigos[0].nombre}: ${describirPedazos(pedazos[0])}. ¿Cuánto es en total?`
                );


                return;
            }


            // ================================================================
            // RESULTADO MENOR QUE 1
            // Ejemplo: 3 / 4 = 3/4
            // ================================================================

            if (
                st.num === null ||
                st.den === null
            ) {

                marcarError(
                    'Completá la fracción.'
                );


                return;
            }


            const fraccionCorrecta =
                st.num *
                cantidadAmigos ===
                chocolates *
                st.den;


            if (
                fraccionCorrecta
            ) {

                etapaCorrecta(
                    `¡Muy bien! A cada uno le toca ${textoResultado()}.`
                );


                return;
            }


            marcarError(
                `Mirá lo que recibió ${amigos[0].nombre}: ${describirPedazos(pedazos[0])}. ¿Cuánto es en total?`
            );


            return;
        }


        // =====================================================================
        // ETAPA 3
        // RECTA
        // =====================================================================

        const recta =
            st.recta;


        if (
            recta.mark === null
        ) {

            marcarError(
                'Marcá en la recta cuánto le toca a cada amigo.'
            );


            return;
        }


        if (
            Math.abs(
                recta.mark -
                valor
            ) <
            0.03
        ) {

            etapaCorrecta(
                '¡Excelente! Lo ubicaste correctamente en la recta numérica.'
            );


            return;
        }


        marcarError(

            (
                recta.mark >
                valor

                    ? 'Te pasaste.'
                    : 'Te quedaste corto.'
            ) +

            (
                recta.B > 0

                    ? ''
                    : ' Podés usar las bandejas para ayudarte.'
            )
        );
    };


    // =========================================================================
    // PLAY
    // =========================================================================

    const verificar = e => {

        e.preventDefault();


        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        comprobar();
    };


    // =========================================================================
    // INICIALIZACIÓN
    // =========================================================================

    useEffect(() => {

        const seleccion =
            seleccionarEjercicios();


        setEjercicios(
            seleccion
        );


        setCount(
            0
        );


        setSt(
            inicial(
                seleccion[0]
            )
        );


        dispatch(
            setearEjercicioAction(
                'M158'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDADO
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M158',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={true}
                    carrito={true}
                    minMay={false}
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !repartoActual
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM158>


            <HeaderEjercicios
                estrellas={true}
                carrito={true}
                minMay={false}
            />


            <ContenidoM158>


                <ContainerFlex
                    height="100%"
                    width="100%"
                    display="flex"
                    direction="column"
                    justify="center"
                    align="center"
                    isCorrect={isCorrect}
                    isIncorrect={isIncorrect}
                    $mantengoMay={true}
                >


                    <ZonaTrabajoM158>


                        {/* ================================================= */}
                        {/* ENUNCIADO                                         */}
                        {/* ================================================= */}

                        <EnunciadoM158>

                            <p>
                                Tenemos
                                {' '}
                                <strong>
                                    {chocolates}
                                </strong>
                                {' '}
                                {
                                    chocolates === 1
                                        ? 'chocolate'
                                        : 'chocolates'
                                }.
                            </p>


                            <p>
                                Somos
                                {' '}
                                <strong>
                                    {cantidadAmigos}
                                </strong>
                                {' '}
                                amigos.
                            </p>


                            <p>
                                Repartimos todo en partes iguales.
                            </p>


                            <h3>
                                ¿Cuánto chocolate le toca a cada uno?
                            </h3>

                        </EnunciadoM158>


                        {/* ================================================= */}
                        {/* CENTRO                                            */}
                        {/* ================================================= */}

                        <ActividadM158>


                            {/* ============================================= */}
                            {/* ETAPAS 1 Y 2                                  */}
                            {/* ============================================= */}

                            {
                                st.etapa < 2 && (

                                    <>

                                        {
                                            st.etapa === 0 && (

                                                <p className="consigna-m158">
                                                    Partí los chocolates. Elegí un amigo y tocá los pedazos que le querés dar.
                                                </p>
                                            )
                                        }


                                        {
                                            st.etapa === 1 && (

                                                <p className="consigna-m158">
                                                    Ahora escribí cuánto chocolate recibió cada amigo.
                                                </p>
                                            )
                                        }


                                        <EscenaM158>

                                            <div className="chocolates-m158">

                                                {
                                                    range(
                                                        chocolates
                                                    )
                                                        .map(
                                                            chocolateIndex => (

                                                                <div
                                                                    key={chocolateIndex}
                                                                    className="chocolate-m158"
                                                                >

                                                                    <Chocolate
                                                                        n={
                                                                            st.partes[
                                                                                chocolateIndex
                                                                            ]
                                                                        }
                                                                        duenos={
                                                                            st.duenos[
                                                                                chocolateIndex
                                                                            ]
                                                                        }
                                                                        activo={
                                                                            activoReparto
                                                                        }
                                                                        onTocar={
                                                                            parteIndex =>
                                                                                tocarChocolate(
                                                                                    chocolateIndex,
                                                                                    parteIndex
                                                                                )
                                                                        }
                                                                    />


                                                                    {
                                                                        activoReparto && (

                                                                            <div className="partir-chocolate-m158">

                                                                                <span>
                                                                                    Partir en:
                                                                                </span>


                                                                                <button
                                                                                    type="button"
                                                                                    style={{
                                                                                        ...botonPequeno,

                                                                                        opacity:
                                                                                            st.partes[
                                                                                                chocolateIndex
                                                                                            ] <= 1

                                                                                                ? 0.4
                                                                                                : 1
                                                                                    }}
                                                                                    disabled={
                                                                                        st.partes[
                                                                                            chocolateIndex
                                                                                        ] <= 1
                                                                                    }
                                                                                    onClick={() =>
                                                                                        partirChocolate(
                                                                                            chocolateIndex,
                                                                                            -1
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    −
                                                                                </button>


                                                                                <span>
                                                                                    {
                                                                                        st.partes[
                                                                                            chocolateIndex
                                                                                        ]
                                                                                    }
                                                                                </span>


                                                                                <button
                                                                                    type="button"
                                                                                    style={{
                                                                                        ...botonPequeno,

                                                                                        opacity:
                                                                                            st.partes[
                                                                                                chocolateIndex
                                                                                            ] >= MAX_PARTES

                                                                                                ? 0.4
                                                                                                : 1
                                                                                    }}
                                                                                    disabled={
                                                                                        st.partes[
                                                                                            chocolateIndex
                                                                                        ] >= MAX_PARTES
                                                                                    }
                                                                                    onClick={() =>
                                                                                        partirChocolate(
                                                                                            chocolateIndex,
                                                                                            1
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    +
                                                                                </button>

                                                                            </div>
                                                                        )
                                                                    }

                                                                </div>
                                                            )
                                                        )
                                                }

                                            </div>

                                        </EscenaM158>


                                        {
                                            st.etapa === 1 && (

                                                <div className="respuesta-central-m158">


                                                    {/* ========================================================= */}
                                                    {/* ENTEROS                                                  */}
                                                    {/* Solo aparece si el resultado tiene parte entera          */}
                                                    {/* ========================================================= */}

                                                    {
                                                        enteroResultado > 0 && (

                                                            <Contador
                                                                valor={st.ent}
                                                                onCambio={
                                                                    valorNuevo =>
                                                                        actualizar({
                                                                            ent:
                                                                                valorNuevo
                                                                        })
                                                                }
                                                                min={0}
                                                                etiqueta="enteros"
                                                                vertical={true}
                                                                disabled={
                                                                    disable ||
                                                                    st.hecho
                                                                }
                                                            />
                                                        )
                                                    }


                                                    {/* ========================================================= */}
                                                    {/* FRACCIÓN                                                  */}
                                                    {/* No aparece cuando el resultado es un entero exacto       */}
                                                    {/* ========================================================= */}

                                                    {
                                                        restoResultado > 0 && (

                                                            <div className="fraccion-m158">

                                                                <Contador
                                                                    valor={st.num}
                                                                    onCambio={
                                                                        valorNuevo =>
                                                                            actualizar({
                                                                                num:
                                                                                    valorNuevo
                                                                            })
                                                                    }
                                                                    min={0}
                                                                    etiqueta="numerador"
                                                                    disabled={
                                                                        disable ||
                                                                        st.hecho
                                                                    }
                                                                />


                                                                <div className="linea-fraccion-m158" />


                                                                <Contador
                                                                    valor={st.den}
                                                                    onCambio={
                                                                        valorNuevo =>
                                                                            actualizar({
                                                                                den:
                                                                                    valorNuevo
                                                                            })
                                                                    }
                                                                    min={1}
                                                                    etiqueta="denominador"
                                                                    disabled={
                                                                        disable ||
                                                                        st.hecho
                                                                    }
                                                                />

                                                            </div>
                                                        )
                                                    }


                                                </div>
                                            )
                                        }

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 3                                       */}
                            {/* ============================================= */}

                            {
                                st.etapa === 2 && (

                                    <>

                                        <p
                                            className="consigna-m158"
                                        >
                                            Marcá en la recta cuánto le toca a cada amigo.
                                        </p>


                                        <EscenaM158
                                            $recta={true}
                                        >

                                            <Recta
                                                limite={limiteRecta}
                                                recta={st.recta}
                                                color={PINTADO}
                                                onTocarParte={tocarRecta}
                                                onClic={marcarRecta}
                                                activo={activoRecta}
                                                etiqueta={etiquetaRecta}
                                            />

                                        </EscenaM158>


                                        <ControlesRecta
                                            recta={st.recta}
                                            limite={limiteRecta}
                                            activo={activoRecta}
                                            onCambio={cambiarRecta}
                                        />

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* FEEDBACK                                      */}
                            {/* ============================================= */}

                            <p
                                className={
                                    feedback

                                        ? feedback.ok

                                            ? 'feedback-m158 ok'
                                            : 'feedback-m158 error'

                                        : 'feedback-m158'
                                }
                            >
                                {
                                    feedback
                                        ? feedback.text
                                        : '.'
                                }
                            </p>


                        </ActividadM158>


                        {/* ================================================= */}
                        {/* LATERAL                                           */}
                        {/* ================================================= */}

                        <LateralM158>


                            {/* ============================================= */}
                            {/* AMIGOS                                        */}
                            {/* ============================================= */}

                            {
                                st.etapa === 0 && (

                                    <div
                                        className="amigos-m158"
                                    >

                                        {
                                            amigos.map(
                                                (
                                                    amigo,
                                                    index
                                                ) => (

                                                    <Amigo
                                                        key={
                                                            amigo.nombre
                                                        }
                                                        amigo={amigo}
                                                        seleccionado={
                                                            activoReparto &&
                                                            st.sel === index
                                                        }
                                                        pedazos={
                                                            pedazos[
                                                                index
                                                            ]
                                                        }
                                                        activo={
                                                            activoReparto
                                                        }
                                                        onClick={() =>
                                                            actualizar({
                                                                sel:
                                                                    index
                                                            })
                                                        }
                                                    />
                                                )
                                            )
                                        }

                                    </div>
                                )
                            }

                            {/* ============================================= */}
                            {/* RESULTADO                                     */}
                            {/* ============================================= */}

                            {
                                st.etapa === 2 && (

                                    <div
                                        className="resultado-m158"
                                    >

                                        <p>
                                            A cada uno le toca:
                                        </p>


                                        <Numero
                                            {...resultado}
                                            size={54}
                                            color={
                                                st.hecho
                                                    ? OK
                                                    : INK
                                            }
                                        />

                                    </div>
                                )
                            }


                        </LateralM158>


                    </ZonaTrabajoM158>


                </ContainerFlex>


            </ContenidoM158>


            <BottomM158>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        st.hecho
                    }
                    onClick={verificar}
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM158>


        </PantallaM158>
    );
};


export default M158;